(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fmd-recommendations-ajax"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const productRecommendationsSection = document.querySelector(
    '.fmd-recommendations-ajax-section-{{ section.id }}'
  );
  if (!productRecommendationsSection) return;

  // Observer => lazy load
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;
    fetch(url)
      .then((response) => response.text())
      .then((htmlString) => {
        const tempEl = document.createElement('div');
        tempEl.innerHTML = htmlString;
        const recommendations = tempEl.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          // Ersetzt den "loading..." Placeholder
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        } else {
          // Falls Shopify nichts liefert:
          productRecommendationsSection.innerHTML =
            '<div class="page-width"><p>No recommendations found.</p></div>';
        }
      })
      .catch((err) => {
        console.error('Error fetching recommendations:', err);
      });
  };

  const observer = new IntersectionObserver(handleIntersection, {
    rootMargin: '0px 0px 200px 0px'
  });
  observer.observe(productRecommendationsSection);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["purelei-product-bundle-builder"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.openConfigurator').forEach((element) => {
    element.addEventListener('click', (e) => {
      e.preventDefault();
      
      _bundleBuilder?.open();
      return false;
    });
  });

  } catch(e) { console.error(e); }
})();
})();
